export default "__VITE_ASSET__Da4p8Uz4__"